import { FC, useEffect, useState } from "react"
import { v4 as uuidv4 } from 'uuid'
import { DocumentType, LoadingStatus } from "../../../../@types/enumsGlobal"
import { DefaultGrid } from "../../../../components/grids/default/defaultGrid"
import { PluginWrapper } from "../../../../components/plugins"
import { IRequestForMovementItemViewDTO } from '../../../../libs/coreapi-dto/documents/requestForMovementItem'
import { RequestForMovementDataProvider } from '../../../../Services/DataProviders/RequestForMovementDataProvider'
import useGridFilter from "../../../../system/hooks/useGridFilter"
import { useAppContext } from "../../../../system/providers/appContextProvider"
import { usePluginContext } from "../../../../system/providers/plugin"

interface RequestForMovementPartyGridProps {
    gridId: string;
    plugin: any;
    data?: any;
    onSelect?: (row: ISelectGridRow | undefined) => void;
    onDoubleClick?: (row: ISelectGridRow) => void;
    forceLoadRequestId?: string;
    getStyleRow?: (row: IGridRow) => string | null;
}

export const RequestForMovementPartyGrid: FC<RequestForMovementPartyGridProps> = (props) => {
    const appCtx = useAppContext();
    const requestForMovementDP = new RequestForMovementDataProvider(appCtx.coreApiService);
    const pluginCtx = usePluginContext();
    const [data, setData] = useState<IRequestForMovementItemViewDTO[]>([]);
    const [totalCount] = useState(0);
    const [gridFilter, dispatchGridFilter] = useGridFilter();
    const [selectedItem, setSelectedItem] = useState<IGridRow>();
    
    useEffect(() => {
        const currentSelectedId = props.forceLoadRequestId || pluginCtx.masterGrid.selectedItem?.idGlobal;
        const isCorrectDocumentType = props.forceLoadRequestId || pluginCtx.masterGrid.document === DocumentType.requestForMovement;

        if (currentSelectedId && isCorrectDocumentType) {
            requestForMovementDP.getItemsView(currentSelectedId, gridFilter, (event, t) => {
                    const expanded = (event as any[]).flatMap((item) => {
                    const lotsRaw: string = item.lots ?? '';
                    const lotsList = lotsRaw.split(',').map((l: string) => l.trim()).filter(Boolean);
                    if (lotsList.length === 0) {
                        return [];
                    }
                    if (lotsList.length === 1) {
                        return [{ ...item, idGlobal: uuidv4() }];
                    }
                    return lotsList.map((lot: string) => ({ ...item, lots: lot, idGlobal: uuidv4() }));
                });
                setData(expanded);
            });
        }
    }, [props.forceLoadRequestId, pluginCtx.masterGrid.selectedItem?.idGlobal, gridFilter]);

    const handleSelect = (row: IGridRow | undefined) => {
        setSelectedItem(row);
        props.onSelect?.(row);
    };
   
    return (
        <PluginWrapper>
            <DefaultGrid
                gridId={props.gridId}
                data={data}
                filter={gridFilter}
                totalCount={totalCount}
                plugin={props.plugin}
                dataProvider={requestForMovementDP}
                getView={(gridFilter, callback) => {
                    const currentSelectedId = props.forceLoadRequestId || pluginCtx.masterGrid.selectedItem?.idGlobal;
                    requestForMovementDP.getItemsView(currentSelectedId as string, gridFilter, (e, t) => {
                        callback(e);
                    });
                }}
                selectedItem={selectedItem}
                onDoubleClick={(row) => props.onDoubleClick?.(row)}
                onSelect={handleSelect}
                onSort={(i) => dispatchGridFilter({ type: "sort", payload: i.propertyName })}
                onFilterDelete={(i) => {
                    dispatchGridFilter({ type: "deleteColumnFilter", payload: i.propertyName });
                }}
                onPageNumberChange={(n) => dispatchGridFilter({ type: "changePageNumber", payload: { pageNumber: n } })}
                onNumberPerPageChange={(n) => dispatchGridFilter({ type: "changeNumberPerPage", payload: { numberPerPage: n } })}
                getStyleRow={props.getStyleRow}
            />
        </PluginWrapper>
    );
}
